module.exports = __webpack_public_path__ + "img/compass.9cb56421.svg";